import type { LogicGameState, PersonState } from "./types.ts";

function sharesParent(left: PersonState, right: PersonState) {
  return left.parentIds.some((id) => right.parentIds.includes(id));
}

function descendantIds(state: LogicGameState, root: PersonState) {
  const found = new Set<string>();
  const queue = [...root.childIds];
  while (queue.length) {
    const id = queue.shift()!;
    if (found.has(id) || !state.people[id]) continue;
    found.add(id);
    queue.push(...state.people[id].childIds);
  }
  return found;
}

function ancestorIds(state: LogicGameState, root: PersonState) {
  const found = new Set<string>();
  const queue = [...root.parentIds];
  while (queue.length) {
    const id = queue.shift()!;
    if (found.has(id) || !state.people[id]) continue;
    found.add(id);
    queue.push(...state.people[id].parentIds);
  }
  return found;
}

export function familyRelationLabel(state: LogicGameState, member: PersonState) {
  const active = state.people[state.activePersonId];
  if (!active) return "家族成員";
  if (member.id === active.id) return "主角";
  if (active.parentIds.includes(member.id)) return member.gender === "male" ? "父親" : "母親";
  if (active.currentPartnerId === member.id) return active.relationshipStage === "married" ? "伴侶" : "交往對象";
  if (active.partnerIds.includes(member.id)) return "前任";
  if (active.childIds.includes(member.id)) {
    if (member.flags.includes("adopted")) return member.gender === "male" ? "養子" : "養女";
    return member.gender === "male" ? "兒子" : "女兒";
  }
  if (sharesParent(active, member)) return member.gender === "male" ? "兄弟" : "姊妹";
  const grandparents = new Set(active.parentIds.flatMap((id) => state.people[id]?.parentIds || []));
  if (grandparents.has(member.id)) return member.gender === "male" ? "祖父輩" : "祖母輩";
  const grandchildren = new Set(active.childIds.flatMap((id) => state.people[id]?.childIds || []));
  if (grandchildren.has(member.id)) return member.gender === "male" ? "孫子" : "孫女";
  if (ancestorIds(state, active).has(member.id)) return "祖先";
  if (descendantIds(state, active).has(member.id)) return "後代";
  return "家族成員";
}

export function householdStatusLabel(state: LogicGameState, member: PersonState) {
  if (member.deathYear) return "已故";
  return member.householdId === state.activeHouseholdId ? "同戶" : "分戶";
}
